import { useState } from "react";
import { type ColorSchemeId } from "@stackje/common/colorScheme";
import { ColorSchemeContext } from "./ColorSchemeContext";

export const ColorSchemeProvider = ({ children }: { children: React.ReactNode }) => {
  const [colorSchemeId, setColorSchemeId] = useState<ColorSchemeId>("natural");
  const [customColors, setCustomColors] = useState<string[] | null>(null);

  return (
    <ColorSchemeContext.Provider value={{
      colorSchemeId,
      setColorSchemeId,
      customColors,
      setCustomColors
    }}>
      {children}
    </ColorSchemeContext.Provider>
  );
};